<template>
	<div>
		<h1>Legacy Site Content</h1>
		<h3 
			v-for="group in groups"
			:key="group.id"
		>
			<router-link :to="{name: 'group', params: {groupName: group.name}}">{{ group.name }}</router-link>
		</h3>
	</div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
	name: 'Legacy',
	computed: {
		...mapState(['groups']),
	},
	created() {
		this.fetchGroups();
	},
	methods: {
		...mapActions(['fetchGroups']),
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
	margin: 40px 0 0;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}
</style>
